// extracted by mini-css-extract-plugin
module.exports = {"help":"TuoBambino_help__dfcLJ","rotation":"TuoBambino_rotation__SUh6k"};